/**
 * @module reporting results
 *
 * This is a set of calculated data combined with entities which are used to
 * represet the results of the user's selections made through the filters.
 * Think of this as the root of the reporting which reference data directly or
 * into other more complex entities.
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {
  attributeReports: [],
  categoryReports: [],
  questionResponses: [],

  // state based on new rest reporting endpoint
  overallResult: null,
  categoryResults: [],
  surveyElementResults: [],
};

const reset = () => defaultState;

const mergeQuestionResponses = (state, action) => {
  const questionResponses = action?.payload?.entities?.questionResponses || {};

  state.questionResponses = Object.keys(questionResponses);
};

const replaceReportingResults = (state, action) => {
  const overallResult = action.payload?.result?.overallResult || null;
  state.overallResult = overallResult;

  const categoryResults = action.payload?.result?.categoryResults || [];
  state.categoryResults = categoryResults;

  const surveyElementResults = Object.keys(action.payload?.entities?.surveyElementResults || {});
  state.surveyElementResults = surveyElementResults;
};

const results = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(reportingActions.fetchQuestionResults.fulfilled, mergeQuestionResponses);

  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, replaceReportingResults);
});

export default results;
